<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'BannerMixin',
  computed: {
    ...mapGetters({
      banner: 'user/banner',
    }),
    $bannerActions() {
      return {
        VIEW_SSO_SUMMARY: 'View SSO Summary',
        // we can have many more actions below if needed...
      };
    },
    $bannerTypes() {
      return {
        SUCCESS: 'success',
        ERROR: 'danger',
        WARNING: 'warning',
        INFO: 'info',
      };
    },
  },
  methods: {
    ...mapMutations('user', ['setBanner']),
    showBanner(bannerType, bannerMessage, bannerAction, bannerTime) {
      this.setBanner({
        show: true,
        variant: bannerType,
        message: this.$sanitize(bannerMessage),
        action: bannerAction,
        time: bannerTime,
      });
    },
    closeBanner() {
      this.setBanner({
        show: false,
        variant: '',
        message: '',
        action: '',
      });
    },
  },
};
</script>
